function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.898 40.108a6.187 6.187 0 11-12.375 0 6.187 6.187 0 1112.375 0z",
  transform: "translate(-4.505 12.289) scale(.93338)",
  strokeWidth: 1.071,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.282 49.725a3.057 3.057 0 11-6.114 0 3.057 3.057 0 116.114 0z",
  strokeWidth: 0.9998964800000001,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  transform: "translate(29.495 12.289) scale(.93338)",
  d: "M20.898 40.108a6.187 6.187 0 11-12.375 0 6.187 6.187 0 1112.375 0z",
  strokeWidth: 1.071,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.282 49.725a3.057 3.057 0 11-6.114 0 3.057 3.057 0 116.114 0z",
  strokeWidth: 0.9998964800000001,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "round",
  d: "M3 23h10v11.069H3zM16.1 23h10v11.069h-10zM29 23h10v11.069H29z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15 49.6h22"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.3 23s6.67-.649 8.7.931c3.588 2.793 2.494 14.897 2.494 14.897-3.588-.931-3.494-2.793-11.194-4.759z",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3 49.069H0V20.207h50c4 0 5.76 3.36 6 5.586C57 35.103 56 50 56 50h-7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55 32a4.5 1 0 11-9 0 4.5 1 0 119 0z",
  transform: "matrix(.79328 -.25923 .21292 .96582 1.556 14.219)",
  strokeWidth: 1.103,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.6 32c2 6 2 5.6 2 5.6"
}));

var SvgBus = function SvgBus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Bus.bdacfff3.svg";
export { ForwardRef as ReactComponent };